import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  getStatusUpdate: null,
}

const getters = {
  getStatusUpdate(issueId) {
    const url = `/MaintenanceIssue/${issueId}/updates`
    return axios.get(url)
  },
}

export default class StatusUpdatesService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
